export const EmailPageHeader = ({ children }: { children: React.ReactNode }) => {
  return <div className="truncate text-2xl font-semibold leading-8 text-slate-800 dark:text-slate-100">{children}</div>;
};
